import React from "react";
import "./singleNews.layout.sass";
import newsData from "../../data/news/news.data";
import StickyNav from "../stickyNav/stickyNav.component";
import DrawerNav from "../../components/drawer/drawer.component";
import NavBar from "../navbar/navbar.component";
import Footer from "../footer/footer.component";
import SingleNewsComponent from "../../components/singleNews/singleNews.component";
import TopOfNav from "../topOfNav/topOfNav.component";
import SubHeaderComponent from "../../components/subHeader/subHeader.component";
import subNewsImage from "../../assets/image/singleNewsHeader.png";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { selectNews } from "../../redux/site/site.selector";
import Axios from "axios";
import { Setting } from "../../setting";
import { SetNews } from "../../redux/site/site.actions";
import { css } from "@emotion/react";
import GridLoader from "../specialFeatures/SpecialFeatures.layout";

const SingleNewsLayout = ({ match, News, SetNews }) => {
  const newsId = match.params.newsId;
  let selectedNews = "";
  if (News) {
    selectedNews = News.find((item) => item.id == newsId);
  } else {
    Axios.get(`${Setting.apiUrl}api/news/list`).then((res) => {
      SetNews(res.data);
    });
  }
  const override = css`
    display: block;
    margin: 40px auto;
    border-color: red;
    position: relative;
  `;
  return (
    <div>
      <TopOfNav />
      <StickyNav />
      <DrawerNav />
      <NavBar />
      {selectedNews === undefined ? (
        <div>
          <SubHeaderComponent imageSrc={subNewsImage} pageName="اخبار" />
          <div className="empty-news-message-div">
            <h2>چنین خبری وجود خارجی ندارد</h2>
          </div>
        </div>
      ) : (
        <div>
          {selectedNews ? (
            <div>
              <SubHeaderComponent
                imageSrc={subNewsImage}
                pageName="اخبار"
                news={selectedNews.title}
              />
              <SingleNewsComponent news={selectedNews} />
            </div>
          ) : (
            <div className="loading-single-news">
              <GridLoader css={override} size={15} margin={8} color="#FF8F3C" />
            </div>
          )}
        </div>
      )}
      <Footer />
    </div>
  );
};
const mapStateToProps = createStructuredSelector({
  News: selectNews,
});
const mapDispatchToProps = (dispatch) => ({
  SetNews: (data) => dispatch(SetNews(data)),
});
export default connect(mapStateToProps, mapDispatchToProps)(SingleNewsLayout);
